import React from 'react';
import MemberTreeList from './MemberTreeList';
import DashboardMemberStatusTitle from './DashboardMemberStatusTitle';

/**
 * 队员状态标题 + 树列表（桌面/移动共用）
 * 桌面标题已并入 DashboardMemberToolbar，默认不再重复渲染「队员状态」。
 */
export default function DashboardMemberTreeBlock({
  variant = 'desktop',
  showTitle = false,
  orgMap,
  openOrg,
  openGroup,
  openMember,
  setOpenOrg,
  setOpenGroup,
  setOpenMember,
  setHighlightedMemberIds,
  highlightedMemberName,
  setHighlightedMemberName,
  setActiveMemberId,
  showTracks,
  isMemberTrackVisible,
  streamingMembers,
  areAllGroupsExpanded,
  areAllMembersExpanded,
  expandOnlineInOrg,
  setOrgGroupsExpanded,
  expandOnlineInGroup,
  setGroupMembersExpanded,
  flyToMember,
  toggleTrack,
  openLiveStream,
  startRealTimeTrackDrawing,
  copyToClipboard,
  openDownloadTrackModal,
  fetchMemberTrack,
  onMemberIconChange,
  realTimeTrackDrawing,
  stopTrackFeatures,
  hiddenMapMemberIds,
  onToggleMemberMapHidden,
  commandFeatures,
  onlineTimeoutMs,
  offlineTimeoutMs,
  presenceById,
  onSendLocationToMember,
  onSendMessageToMember,
  missionSelectable = false,
  missionPickIds = null,
  onMissionPickToggle,
  onMissionPickMany,
  missionMemberIdSet = null,
  notesByKey = null,
  onSaveMemberNote,
  missions = null,
  voicePulseIds = null
}) {
  return (
    <>
      {showTitle ? <DashboardMemberStatusTitle variant={variant} /> : null}
      <MemberTreeList
        variant={variant}
        orgMap={orgMap}
        openOrg={openOrg}
        openGroup={openGroup}
        openMember={openMember}
        setOpenOrg={setOpenOrg}
        setOpenGroup={setOpenGroup}
        setOpenMember={setOpenMember}
        setHighlightedMemberIds={setHighlightedMemberIds}
        highlightedMemberName={highlightedMemberName}
        setHighlightedMemberName={setHighlightedMemberName}
        setActiveMemberId={setActiveMemberId}
        showTracks={showTracks}
        isMemberTrackVisible={isMemberTrackVisible}
        streamingMembers={streamingMembers}
        areAllGroupsExpanded={areAllGroupsExpanded}
        areAllMembersExpanded={areAllMembersExpanded}
        expandOnlineInOrg={expandOnlineInOrg}
        setOrgGroupsExpanded={setOrgGroupsExpanded}
        expandOnlineInGroup={expandOnlineInGroup}
        setGroupMembersExpanded={setGroupMembersExpanded}
        flyToMember={flyToMember}
        toggleTrack={toggleTrack}
        openLiveStream={openLiveStream}
        startRealTimeTrackDrawing={startRealTimeTrackDrawing}
        copyToClipboard={copyToClipboard}
        openDownloadTrackModal={openDownloadTrackModal}
        fetchMemberTrack={fetchMemberTrack}
        onMemberIconChange={onMemberIconChange}
        realTimeTrackDrawing={realTimeTrackDrawing}
        stopTrackFeatures={stopTrackFeatures}
        hiddenMapMemberIds={hiddenMapMemberIds}
        onToggleMemberMapHidden={onToggleMemberMapHidden}
        commandFeatures={commandFeatures}
        onlineTimeoutMs={onlineTimeoutMs}
        offlineTimeoutMs={offlineTimeoutMs}
        presenceById={presenceById}
        onSendLocationToMember={onSendLocationToMember}
        onSendMessageToMember={onSendMessageToMember}
        missionSelectable={missionSelectable}
        missionPickIds={missionPickIds}
        onMissionPickToggle={onMissionPickToggle}
        onMissionPickMany={onMissionPickMany}
        missionMemberIdSet={missionMemberIdSet}
        notesByKey={notesByKey}
        onSaveMemberNote={onSaveMemberNote}
        missions={missions}
        voicePulseIds={voicePulseIds}
      />
    </>
  );
}
